
import Chart from 'chart.js';
import { generateChart } from 'vue-chartjs'
import { isMobile } from "../../../../utility";
Chart.elements.RoundedTopRectangle = Chart.elements.Rectangle.extend({
    draw: function () {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var left, right, top, bottom, signX, signY, borderSkipped, radius;
        var borderWidth = vm.borderWidth;
        var cornerRadius = 30;
        if (!vm.horizontal) {
            // bar
            left = vm.x - vm.width / 2;
            right = vm.x + vm.width / 2;
            top = vm.y;
            bottom = vm.base;
            signX = 1;
            signY = bottom > top ? 1 : -1;
            borderSkipped = vm.borderSkipped || 'bottom';
        } else {
            // horizontal bar
            left = vm.base;
            right = vm.x;
            top = vm.y - vm.height / 2;
            bottom = vm.y + vm.height / 2;
            signX = right > left ? 1 : -1;
            signY = 1;
            borderSkipped = vm.borderSkipped || 'left';
        }

        if (borderWidth) {
            var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
            borderWidth = borderWidth > barSize ? barSize : borderWidth;
            var halfStroke = borderWidth / 2;
            var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
            var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
            var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
            var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
            if (borderLeft !== borderRight) {
                top = borderTop;
                bottom = borderBottom;
            }
            if (borderTop !== borderBottom) {
                left = borderLeft;
                right = borderRight;
            }
        }

        ctx.beginPath();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = borderWidth;
        var corners = [
            [left, bottom],
            [left, top],
            [right, top],
            [right, bottom]
        ];

        var borders = ['bottom', 'left', 'top', 'right'];
        var startCorner = borders.indexOf(borderSkipped, 0);
        if (startCorner === -1) {
            startCorner = 0;
        }

        function cornerAt(index) {
            return corners[(startCorner + index) % 4];
        }
        var corner = cornerAt(0);
        ctx.moveTo(corner[0], corner[1]);

        for (var i = 1; i < 4; i++) {
            corner = cornerAt(i);
            var nextCornerId = i + 1;
            if (nextCornerId == 4) {
                nextCornerId = 0
            }

            var nextCorner = cornerAt(nextCornerId);
            var width = corners[2][0] - corners[1][0];
            var height = corners[0][1] - corners[1][1];
            var x = corners[1][0];
            var y = corners[1][1];
            var radius = cornerRadius;
            if (radius > height / 2) {
                radius = height / 2;
            } if (radius > width / 2) {
                radius = width / 2;
            }

            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);

        }

        ctx.fill();
        if (borderWidth) {
            ctx.stroke();
        }
    }

})
Chart.defaults.RoundedBar = Chart.helpers.clone(Chart.defaults.bar);
Chart.controllers.RoundedBar = Chart.controllers.bar.extend({
    dataElementType: Chart.elements.RoundedTopRectangle
});
const RoundedBarChart = generateChart('rounded-bar', 'RoundedBar')


export default {
    extends: RoundedBarChart,
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        appDrawer: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: ""
        },
        default_currency: {
            type: String,
            default: ""
          }
    },
    watch: {
        appDrawer: function (newVal, oldVal) {
        }

    },
    data: () => ({

        options: {
            responsive: true,
            maintainAspectRatio: false,

            title: {
                display: false,
                position: 'top',
                text: '',
                fontStyle: 'bold',
                padding: 15,
                align: 'start'
            },
            legend: {
                display: false,
            },
            tooltips: {
                callbacks: {
                    label:  (tooltipItem)=> {
                        return Number(tooltipItem.xLabel).toFixed(2)  +' '+ window.b2b_default_currency;
                    }
                }
            },

            scales: {
                xAxes: [{

                    ticks: {
                        beginAtZero: true,
                        min: 0,
                        callback: function (value, index, values) {
                            return value > 1000 ? value / 1000 + "k" : value;
                        }
                    }
                }],
                xAxes: [
                    {

                        ticks: {
                            callback: function (label) {
                                return !isMobile() && label.length > 40 ? label.substr(0, 40) + '...' : isMobile() && label.length > 10 ? label.substr(0, 10) + '...' : label;
                            }
                        }
                    }
                ],



            }
        }
    }),

    mounted() {
        this.renderChart(this.chartdata, this.options)
    },

}

